import styled from 'styled-components'

export const Container = styled.div`
  position: fixed;
  bottom: 20px;
  right: 40px;
`

export const HelpButtonCont = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  line-height: 1rem;
  font-weight: 600;
  color: ${({ theme }) => `rgb(${theme.background.high})`};
  background: ${({ theme }) => `rgb(${theme.primary.base})`};
  padding: 0.6875rem 1.2rem;
  border: none;
  border-radius: 20px;

  .IconButton {
    margin-right: 4px;
  }
`
